// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2Q26p","log":"ModalInventoryLogs_log__3cywk","date":"ModalInventoryLogs_date__3Untf","userName":"ModalInventoryLogs_userName__GuAQb"};